var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilestoring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.492,
    height: 25.654,
    viewBox: "0 0 32.492 25.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -53.873)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 53.873)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.763,62.836A9.085,9.085,0,0,0,7.787,61.094H7.7a7.7,7.7,0,1,0,0,15.4h5.378a.693.693,0,1,0,0-1.386H7.7a6.314,6.314,0,1,1,0-12.629c.185,0,.382.01.6.03a.693.693,0,0,0,.752-.6,7.7,7.7,0,0,1,15.327,1.049c0,.153-.011.311-.023.477l-.005.071a.693.693,0,0,0,.761.738,5.528,5.528,0,0,1,.553-.028,5.444,5.444,0,1,1,0,10.887H20.008a.693.693,0,0,0,0,1.386h5.655a6.829,6.829,0,0,0,.1-13.658Z",
    transform: "translate(0 -53.873)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.899 57.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.515,105.192a5.845,5.845,0,0,0-5.769,5.037.693.693,0,0,0,.593.78.7.7,0,0,0,.094.006.693.693,0,0,0,.686-.6,4.454,4.454,0,0,1,4.4-3.838.693.693,0,0,0,0-1.386Z",
    transform: "translate(-171.74 -105.192)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.029 68.222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.1,282.525l-2.521-2.252a1.143,1.143,0,0,0-1.525,0l-2.521,2.252a.693.693,0,0,0,.923,1.034l1.667-1.489v8.525a.693.693,0,1,0,1.386,0V282.07l1.667,1.489a.693.693,0,1,0,.923-1.034Z",
    transform: "translate(-205.302 -279.982)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilestoring);
export default __webpack_public_path__ + "static/media/filestoring.ddd3da7c.svg";
export { ForwardRef as ReactComponent };